module.exports = __webpack_public_path__ + "img/bug.61d7db03.svg";